import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OportunidadeMotivoPricing } from 'app/interfaces/enum/oportunidade-motivo-pricing';
import { StatusOportunidadeOferta } from 'app/interfaces/enum/status-oportunidade-oferta';
import { TipoEmailOportunidadeOferta } from 'app/interfaces/enum/tipo-email-oportunidade-oferta';
import { HomeOportunidadeOfertasVendedor } from 'app/interfaces/home-oportunidade-ofertas-vendedor copy';
import { OportunidadeAnalise } from 'app/interfaces/oportunidade-analise';
import { OportunidadeOferta } from 'app/interfaces/oportunidade-oferta';
import { OportunidadeOfertaControleBooking } from 'app/interfaces/oportunidade-oferta-controle-booking';
import { OportunidadeOfertaResumoCusto } from 'app/interfaces/oportunidade-oferta-resumo-custo';
import { OportunidadeOfertaVolume } from 'app/interfaces/oportunidade-oferta-volume';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { TimezoneService } from 'app/utils/timezone.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OportunidadeOfertaHttpService {
  constructor(
    private _http: HttpClient,
    private _timezoneService: TimezoneService
  ) {}

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  getAll({
    oportunidade = '',
    agente = '',
    origem = '',
    destino = '',
    destinoFinal = '',
    cliente = '',
    insideSales = '',
    pricing = '',
    vendedor = '',
    familia = '',
    referenciaCliente = '',
    dataOportunidadeInicial = '',
    dataOportunidadeFinal = '',
    page = 0,
    sort = '',
    oportunidadeId = null,
    size = 200,
    status = [],
  }: {
    oportunidade?: string;
    agente?: string;
    origem?: string;
    destino?: string;
    destinoFinal?: string;
    cliente?: string;
    insideSales?: string;
    pricing?: string;
    vendedor?: string;
    familia?: string;
    referenciaCliente?: string;
    dataOportunidadeInicial: string;
    dataOportunidadeFinal: string;
    page?: number;
    sort?: string;
    oportunidadeId?: number;
    size?: number;
    status?: StatusOportunidadeOferta[];
  }) {
    let params = {
      oportunidade: oportunidade,
      agente: agente,
      origem: origem,
      destino: destino,
      destinoFinal: destinoFinal,
      cliente: cliente,
      insideSales: insideSales,
      pricing: pricing,
      vendedor: vendedor,
      familia: familia,
      referenciaCliente: referenciaCliente,
      dataOportunidadeInicial: dataOportunidadeInicial,
      dataOportunidadeFinal: dataOportunidadeFinal,
      oportunidadeId: oportunidadeId ? oportunidadeId : '',
      page: page,
      sort: sort,
      size: size ? size : '',
      status: status ? status : [],
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas`, { params: params });
  }

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  getAllGrid({
    oportunidade = '',
    agente = '',
    origem = '',
    destino = '',
    destinoFinal = '',
    cliente = '',
    insideSales = '',
    pricing = '',
    vendedor = '',
    familia = '',
    referenciaCliente = '',
    dataOportunidadeInicial = '',
    dataOportunidadeFinal = '',
    page = 0,
    sort = '',
    oportunidadeId = null,
    quantidadeProcessos = null,
    size = 200,
    status = [],
  }: {
    oportunidade?: string;
    agente?: string;
    origem?: string;
    destino?: string;
    destinoFinal?: string;
    cliente?: string;
    insideSales?: string;
    pricing?: string;
    vendedor?: string;
    familia?: string;
    referenciaCliente?: string;
    dataOportunidadeInicial: string;
    dataOportunidadeFinal: string;
    page?: number;
    sort?: string;
    oportunidadeId?: number;
    quantidadeProcessos?: number;
    size?: number;
    status?: StatusOportunidadeOferta[];
  }) {
    let params = {
      oportunidade: oportunidade,
      agente: agente,
      origem: origem,
      destino: destino,
      destinoFinal: destinoFinal,
      cliente: cliente,
      insideSales: insideSales,
      pricing: pricing,
      vendedor: vendedor,
      familia: familia,
      referenciaCliente: referenciaCliente,
      dataOportunidadeInicial: dataOportunidadeInicial,
      dataOportunidadeFinal: dataOportunidadeFinal,
      oportunidadeId: oportunidadeId ? oportunidadeId : '',
      quantidadeProcessos: quantidadeProcessos ? quantidadeProcessos : '',
      page: page,
      sort: sort,
      size: size ? size : '',
      status: status ? status : [],
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/grid`, { params: params });
  }

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  getAllListarEmOportunidade({
    oportunidade = '',
    agente = '',
    origem = '',
    destino = '',
    destinoFinal = '',
    cliente = '',
    insideSales = '',
    pricing = '',
    vendedor = '',
    familia = '',
    page = 0,
    sort = '',
    oportunidadeId = null,
  }: {
    oportunidade?: string;
    agente?: string;
    origem?: string;
    destino?: string;
    destinoFinal?: string;
    cliente?: string;
    insideSales?: string;
    pricing?: string;
    vendedor?: string;
    familia?: string;
    page?: number;
    sort?: string;
    oportunidadeId?: number;
  }) {
    let params = {
      oportunidade: oportunidade,
      agente: agente,
      origem: origem,
      destino: destino,
      destinoFinal: destinoFinal,
      cliente: cliente,
      insideSales: insideSales,
      pricing: pricing,
      vendedor: vendedor,
      familia: familia,
      oportunidadeId: oportunidadeId ? oportunidadeId : '',
      page: page,
      sort: sort,
      size: 9999,
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/listar-em-oportunidade`, { params: params });
  }

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  getAllByOportunidadeIdDTOMinimo({ oportunidadeId = null }: { oportunidadeId?: number }) {
    let params = {
      oportunidadeId: oportunidadeId ? oportunidadeId : '',
    };
    return this._http.get<OportunidadeOferta[]>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/oportunidade-minimo`, { params: params });
  }

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  getResumoCustosByOportunidadeOfertaId(oportunidadeOfertaId: number) {
    return this._http.get<OportunidadeOfertaResumoCusto>(
      `${environment.apiUrl}/api/process/v1/oportunidade-ofertas/resumo-custos/${oportunidadeOfertaId}`
    );
  }

  /**
   * Função para buscar todas parceiro-negocios;
   * @param filtro
   * @param page
   * @param sort
   * @returns
   */
  updateResumoCustosByOfertaId(oportunidadeOfertaId: number, validaCamposCustos = false as Boolean) {
    const params = {
      'valida-campos-custos': validaCamposCustos,
    };
    return this._http.put<OportunidadeOfertaResumoCusto>(
      `${environment.apiUrl}/api/process/v1/oportunidade-ofertas/resumo-custos/${oportunidadeOfertaId}?valida-campos-custos=${validaCamposCustos}`,
      null
    );
  }

  /**
   * Função para buscar a oferta pelo id;
   * @param id
   * @returns
   */
  getById(id: number) {
    return this._http.get<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/${id}`);
  }

  /**
   * Função para buscar a oferta pelo id e oportunidadeId;
   * @param id
   * @returns
   */
  getByIdSelecao(id: number, oportunidadeId: number) {
    const params = { oportunidadeId };
    return this._http.get<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/selecao/${id}`, { params });
  }

  /**
   * Validar se campos obrigatórios estão preenchidos em todas as ofertas selecionadas
   * @param ids
   * @param motivo
   * @returns
   */
  validarCamposObrigatoriosPricing(oportunidadeId: number, oportunidadeOfertaIds: number[], motivo: OportunidadeMotivoPricing) {
    const params = {
      oportunidadeOfertaIds: oportunidadeOfertaIds.join(','),
      oportunidadeId: oportunidadeId,
      motivo: motivo,
    };
    return this._http.get<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/validar-campos-obrigatorios-pricing`, {
      params,
    });
  }

  /**
   * Função para salvar uma oferta;
   * @param oportunidadeOferta
   * @returns
   */
  salvar(oportunidadeOferta: OportunidadeOferta) {
    return this._http.post<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas`, oportunidadeOferta);
  }

  /**
   * Função para replicar uma oferta;
   * @param oportunidadeOferta
   * @returns
   */
  replicar(idReplicado: number, replicarCustos: boolean) {
    const params = {
      replicarCustos: replicarCustos,
    };
    return this._http.get<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/replicar/${idReplicado}`, { params });
  }

  /**
   * Função para salvar uma oportunidade;
   * @param oportunidadeOferta
   * @returns
   */
  salvarRapido(oportunidadeOferta: OportunidadeOferta) {
    return this._http.post<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/criacao-rapida`, oportunidadeOferta);
  }

  /**
   * Função para atualizr o status de uma oferta;
   * @param oportunidadeOfertaId
   * @param Status
   * @returns
   */
  atualizarStatusPorEnvioDeEmail(id: number, oportunidadeId: number, tipoEmail: TipoEmailOportunidadeOferta) {
    const params = {
      tipoEmail: tipoEmail,
      oportunidadeId: oportunidadeId,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/atualiza-status-email-enviado/${id}`, { params });
  }

  /**
   * Função para atualizar uma oportunidade;
   * @param oportunidadeOferta
   * @returns
   */
  update(oportunidadeOferta: OportunidadeOferta) {
    return this._http.put<OportunidadeOferta>(
      `${environment.apiUrl}/api/process/v1/oportunidade-ofertas/${oportunidadeOferta.oportunidadeOfertaId}`,
      oportunidadeOferta
    );
  }

  aprovarOferta(oportunidadeId: number, oportunidadeOferta: OportunidadeOferta) {
    const params = {
      oportunidadeId: oportunidadeId,
      oportunidadeOfertaId: oportunidadeOferta.oportunidadeOfertaId,
    };
    return this._http.get<OportunidadeOferta[]>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/aprovar-oferta`, { params });
  }

  /**
   * Delete um registro;
   * @param id
   * @returns
   */
  delete(id: number) {
    return this._http.delete<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/${id}`);
  }

  /**
   * Função só buscar somente oportunidadeOfertas (livres de dependencias)
   * @returns
   */
  getOportunidadeOfertas() {
    return this._http.get<OportunidadeOferta[]>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/all`);
  }

  /**
   * Função para buscar última oferta da mesma rota por status;
   * @param origemId
   * @param destinoId
   * @param status
   * @returns
   */
  findMostRecentOfertaRotaByStatus(origemId: number, destinoId: number, status: StatusOportunidadeOferta) {
    const params = {
      origemId: origemId,
      destinoId: destinoId,
      status: status.toUpperCase(),
    };
    return this._http.get<OportunidadeAnalise>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/mais-recente-rota`, { params });
  }

  /**
   * Função para atualizar uma oportunidade;
   * @param oportunidadeOferta
   * @returns
   */
  geraProcessoExtra(oportunidadeOfertaId: number, quantidade: number) {
    const params = {
      quantidade: quantidade,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/gera-processo-extra/${oportunidadeOfertaId}`, {
      params,
    });
  }

  geraProcessoPelaOferta(ofertaId: number) {
    return this._http.get<number>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/gera-processo-pela-oferta`, {
      params: { ofertaId },
    });
  }

  /**
   * Função para buscar a oferta mais antiga da oportunidade pelo oportunidadeId;
   * @param oportunidadeId
   * @returns
   */
  getOfertaMaisAntigaByOportunidadeId(oportunidadeId: number) {
    const params = {
      oportunidadeId: oportunidadeId,
    };
    return this._http.get<OportunidadeOferta>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/mais-antiga`, { params });
  }

  solicitarBooking(ofertaId: number) {
    const params = {
      ofertaId: ofertaId,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/solicitar-booking`, { params });
  }

  getAllAudit(faturaId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(
      `${environment.apiUrl}/api/process/v1/oportunidades-ofertas-auditorias

/${faturaId}`,
      { params: params }
    );
  }

  findOfertasByCodigo(codigoOferta: string) {
    return this._http.get<OportunidadeOferta[]>(
      `${environment.apiUrl}/api/process/v1/oportunidade-ofertas/find-ofertas-by-codigo?codigoOferta=${codigoOferta}`
    );
  }

  salvaNCMsOferta(ncms: string, ofertaId: number) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/salvar-ncms-oferta/${ofertaId}?ncms=${ncms}`, null);
  }

  aprovarOfertaLiberarEnvio(oportunidadeId: number, oportunidadeOferta: OportunidadeOferta, liberarEnvio: boolean) {
    const params = {
      oportunidadeId: oportunidadeId,
      oportunidadeOfertaId: oportunidadeOferta.oportunidadeOfertaId,
      liberarEnvio: liberarEnvio,
    };
    return this._http.get<OportunidadeOferta[]>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/aprovar-oferta-liberar-envio`, { params });
  }

  isTarifarioDentroFaixaPeso(oportunidadeOferta: OportunidadeOferta) {
    return this._http.post<boolean>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/verificar-faixa-peso-tarifario`, oportunidadeOferta);
  }

  getAuditComparacao(oportunidadeOfertaId: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process/v1/oportunidades-ofertas-auditorias/comparacao-audit/
    ${oportunidadeOfertaId}?rev=${rev}`);
  }

  findOfertasByCodigoControleBooking(codigoOferta: string) {
    return this._http.get<OportunidadeOfertaControleBooking[]>(
      `${environment.apiUrl}/api/process/v1/oportunidade-ofertas/find-ofertas-by-codigo-controle-booking?codigoOferta=${codigoOferta}`
    );
  }

  getResultadoCalculoCubagem(volume: OportunidadeOfertaVolume) {
    return this._http.post<OportunidadeOfertaVolume>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/calcular-cubagem`, volume);
  }

  getInformacaoGraficoOportunidadeOfertasVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    const params: any = { vendedorId };

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<HomeOportunidadeOfertasVendedor[]>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/resumo-ofertas-by-vendedor`, {
      params,
    });
  }

  getOfertasAprovadasValidasByCodigo(codigoOferta: string) {
    let params: {
      page: number;
      size: number;
      codigoOferta: string;
    } = {
      page: 0,
      size: 200,
      codigoOferta,
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process/v1/oportunidade-ofertas/ofetas-aprovadas-validas-by-codigo`, { params });
  }
}
